// Contact form on the contact page, submitted to Formie over ajax. On success the visitor goes to the
// confirmation page set in Formie; the inline confirmation is the fallback when the form has none.
window.contactForm = function (config) {
    return {
        topic: '',
        sent: false,
        submitting: false,
        serverErrors: [],
        init() {
            // Coming back from the confirmation page via the back/forward cache
            window.addEventListener('pageshow', (event) => {
                if (event.persisted) {
                    this.submitting = false;
                }
            });
        },
        toggleTopic(value) {
            this.topic = this.topic === value ? '' : value;
        },
        async submit(event) {
            const form = event.target;
            this.submitting = true;
            this.serverErrors = [];
            let redirecting = false;

            try {
                const result = await window.submitFormie(form, config);

                if (result.success && result.redirectUrl) {
                    // Keep the button disabled while the confirmation page loads
                    redirecting = true;
                    window.location.assign(result.redirectUrl);
                    return;
                }

                if (result.success) {
                    this.sent = true;
                    this.topic = '';
                    form.reset();
                    this.$nextTick(() => this.$refs.confirmation.focus());
                    return;
                }

                this.serverErrors = result.errors.length ? result.errors : [config.messages.generic];
            } catch (error) {
                this.serverErrors = [config.messages.generic];
            } finally {
                this.submitting = redirecting;
            }
        },
        restart() {
            this.sent = false;
            this.serverErrors = [];
        },
    };
}
